import classNames from 'classnames';
import { useId, useRef } from 'react';
import { useCloseOnOutsideOrEscape } from '../../../hooks';
import {
  BUTTON_TEXT_CLASS_NAME,
  DANGER_BUTTON_CLASS_NAME,
  DIALOG_CLASS_NAME,
  OVERLAY_CLASS_NAME,
  SECONDARY_BUTTON_CLASS_NAME,
} from '../StartScreen/styles';

interface IConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: IConfirmDialogProps) {
  const dialogRef = useRef<HTMLDivElement>(null);
  const titleId = useId();
  const messageId = useId();

  useCloseOnOutsideOrEscape(dialogRef, true, onCancel);

  return (
    <div className={classNames(OVERLAY_CLASS_NAME, 'z-50')}>
      <div
        ref={dialogRef}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        className={classNames(DIALOG_CLASS_NAME, 'gap-[6px]')}
      >
        <h2 id={titleId} className="text-[17px] font-bold">
          {title}
        </h2>
        <span id={messageId} className="text-[14px] font-medium text-ink-muted">
          {message}
        </span>
        <div className="mt-[14px] flex gap-[8px]">
          <button
            autoFocus
            onClick={onCancel}
            className={classNames(SECONDARY_BUTTON_CLASS_NAME, 'flex-1')}
          >
            <span className={BUTTON_TEXT_CLASS_NAME}>{cancelLabel}</span>
          </button>
          <button
            onClick={onConfirm}
            className={classNames(DANGER_BUTTON_CLASS_NAME, 'flex-1')}
          >
            <span className={BUTTON_TEXT_CLASS_NAME}>{confirmLabel}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
